import React, { memo } from "react";
import PropType from "prop-types";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { STRIPE_TEST_KEY } from "../../constant/constant";

const StripeElement = ({ children }) => {
  const stripePromise = loadStripe(STRIPE_TEST_KEY);
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

StripeElement.propTypes = {
  children: PropType.node.isRequired,
};

export default memo(StripeElement);
